module.exports = __webpack_public_path__ + "img/logo-text.27b1e05b.svg";